import { HttpStatusCode, isAxiosError } from 'axios';
import aqilaApi from './aqila-api';
import AuthSession from './auth-session';
import { User } from '../@types';
import MissingTokenError from './errors/missing-token';
import InvalidCredentialsError from './errors/invalid-credentials';
import UnexpectedLoginResponseError from './errors/unexpected-login-response';

interface LoginParams {
  login: string;
  senha: string;
}

class Auth {
  async login({ login, senha }: LoginParams) {
    try {
      const response = await aqilaApi.post<User>('v1/login', {
        username: login.toUpperCase(),
        password: senha.toUpperCase(),
      });

      if (!response || !response.data) throw new UnexpectedLoginResponseError();

      const user = response.data;

      if (!user?.token) throw new MissingTokenError();

      AuthSession.login({ user });

      return user;
    } catch (error) {
      if (
        isAxiosError(error) &&
        error.response?.status === HttpStatusCode.Unauthorized
      ) {
        throw new InvalidCredentialsError();
      }

      throw error;
    }
  }
}

export default new Auth();
